<template><div><h1 id="verarbeitungsarten" tabindex="-1"><a class="header-anchor" href="#verarbeitungsarten"><span>Verarbeitungsarten</span></a></h1>
<p>Verarbeitungsarten — Definiert Parameter für das Versandsystem</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Verarbeitungsarten definieren neben der <RouteLink to="/referenz/refs/ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</RouteLink> eine weitere Eigenschaft von Aufträgen. Sie wird üblicherweise für die Trennung von Schnellversänden (Express) und Normalversand verwendet.</p>
<p>Die Fakturierung von Aufträgen geschieht immer nach Verarbeitungsarten getrennt. Damit kann beim Packen eine bestimmte Verarbeitungsart separat behandelt werden.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Verarbeitungsarten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Verarbeitungsart</dt>
<dd>Bezeichnung der Verarbeitungsart</dd>
<dt>Beschreibung</dt>
<dd>Eine längere Beschreibung zum Verarbeitungsart.</dd>
<dt>Verarbeitungsdatum</dt>
<dd>Definiert den Zeitpunkt der Verarbeitung. Auswahl aus dem Dropdown-Menu:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>aktuelles Datum</td>
<td>Verarbeitung am selben Tag</td>
</tr>
<tr>
<td>nächster Tag</td>
<td>Verarbeitung am Folgetag</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html" title="Kapitel 4. Verkauf und Logistik">Auftragsverwaltung</RouteLink></p>
</div></template>


